import axios from 'axios'
// import Vuetify from 'vuetify'

/**
 * Per accedere globalmente a questo modulo usare rootState, rootGetters negli altri moduli
 * 
 * Esempio:
 * getters: {
 *  getRoute(state, getters, rootState) {
 *    return rootState.route;
 *   }
 * }
 */

export default {
	namespaced: true,
	
	state: {
		conAggiornamentiNellePratiche: {
			default: false,
			valueNonApplied: false,
			value: false
		}
	},

	getters: {
		defaultFilters(state) {
			let defaultFilters = {};
			for (let stateKey in state) {
				defaultFilters[stateKey] = state[stateKey].default;
			}
			return defaultFilters;
		},
		thereAreFiltersApplied(state) {
			let thereAreFiltersApplied = false;
			for (let stateKey in state) {
				if (state[stateKey].value != state[stateKey].default) {
					thereAreFiltersApplied = true;
				}
			}
			return thereAreFiltersApplied;
		},
		conAggiornamentiNellePratiche (state) {
			return state.conAggiornamentiNellePratiche;
		}
	},

	mutations: { // è il setter dello store, è sincrona, quindi meglio non usarla per fare chiamate api
		SET_CON_AGGIORNAMENTI_NELLE_PRATICHE_NON_APPLIED (state, value) {
			state.conAggiornamentiNellePratiche.valueNonApplied = value;
		}
	},

	actions: { // sono asincrone, posso fare chiamate api e richiamare poi la mutation
		applyFilters({ state }) {
			for (let stateKey in state) {
				state[stateKey].value = state[stateKey].valueNonApplied;
			}
		},
		resetFilters({ state }) {
			for (let stateKey in state) {
				state[stateKey].value = state[stateKey].default;
				state[stateKey].valueNonApplied = state[stateKey].default;
			}
		}
	}
}

// export default {
// 	namespaced: true,
// 	state,
// 	getters,
// 	mutations,
// 	actions
// }